import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import {
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
} from '@mui/material';
import { store } from 'Store';
import { Provider } from 'react-redux';
import { ThemeV2_0 } from 'ThemeV2.0';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from 'B2C';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
// import { StrictMode } from 'react';

export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize().catch((error) => {
  console.error('MSAL initialization failed:', error);
});

const cache = createCache({
  key: 'css',
  prepend: true,
});

// Get the root element
const rootElement = document.getElementById('root');

if (rootElement !== null) {
  const root = createRoot(rootElement);
  root.render(
    // <StrictMode>
    <StyledEngineProvider injectFirst>
      <CacheProvider value={cache}>
        <ThemeProvider theme={ThemeV2_0}>
          <CssBaseline />
          <Provider store={store}>
            <App msalInstance={msalInstance} />
          </Provider>
        </ThemeProvider>
      </CacheProvider>
    </StyledEngineProvider>,
    //  </StrictMode>,
  );
} else {
  console.error('Root element with ID "root" not found in the DOM');
}
